// Öffentliche Seiten ohne Login (Termin-Antwort, Buchung, Selbstauskunft, Signieren). App.tsx zeigt sie vor jeder
// Sitzungsprüfung – #613: die Bereichs-Weiterleitung für Team-Mitglieder darf sie nicht anfassen (sonst hielt sie
// z. B. den Signier-Token für einen gesperrten Bereich und sprang sofort auf die Startseite).
export function istOeffentlicheSeite(pfad: string): boolean {
  return pfad === '/termin-antwort' || ['/buchen/', '/selbstauskunft/', '/signieren/'].some(p => pfad.startsWith(p));
}
